import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import icone from "@/assets/logo-light.png";
import { useIdentidade } from "@/lib/identidade";

const K_INSTALL = "trt_install_dismissed";
const K_VERSAO_ADIADA = "trt_update_adiada";
const standalone = () => window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

export const InstrucoesInstalacao = () => (
  <div className="space-y-2 text-sm text-slate-700" data-testid="instrucoes-instalacao">
    <p><b>Android (Chrome):</b> abra o menu do navegador (⋮) e toque em <b>Instalar aplicativo</b> ou <b>Adicionar à tela inicial</b>.</p>
    <p><b>iPhone/iPad (Safari):</b> toque em <b>Compartilhar</b> (quadrado com seta) e depois em <b>Adicionar à Tela de Início</b>.</p>
    <p className="text-xs text-slate-500">É apenas uma orientação: a instalação é feita pelo próprio navegador.</p>
  </div>
);

/** Pop-up único: orientação de instalação (1ª vez, fora do modo instalado) e/ou nova versão disponível (service worker em espera). */
export const AvisosApp = () => {
  const ident = useIdentidade();
  const [install, setInstall] = useState(false);
  const [update, setUpdate] = useState(null); // registration com worker em espera
  useEffect(() => {
    if (!standalone() && !localStorage.getItem(K_INSTALL)) setInstall(true);
    if (!("serviceWorker" in navigator)) return;
    let reg;
    const check = (r) => { if (r?.waiting && sessionStorage.getItem(K_VERSAO_ADIADA) !== "1") setUpdate(r); };
    navigator.serviceWorker.getRegistration().then((r) => {
      reg = r; if (!r) return; check(r);
      r.addEventListener("updatefound", () => { const nw = r.installing; nw?.addEventListener("statechange", () => { if (nw.state === "installed" && navigator.serviceWorker.controller) check(r); }); });
    });
    let recarregando = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => { if (!recarregando) { recarregando = true; window.location.reload(); } });
    return () => { void reg; };
  }, []);
  if (!install && !update) return null;
  const fecharInstall = () => { localStorage.setItem(K_INSTALL, new Date().toISOString()); setInstall(false); };
  const atualizar = () => {
    const sujo = document.querySelector("form[data-dirty='true'], [data-unsaved='true']");
    if (sujo && !window.confirm("Há alterações não salvas nesta tela. Salve antes de atualizar. Deseja atualizar mesmo assim?")) return;
    update.waiting?.postMessage({ type: "SKIP_WAITING" }); setUpdate(null);
  };
  const adiar = () => { sessionStorage.setItem(K_VERSAO_ADIADA, "1"); setUpdate(null); };
  return (
    <Dialog open onOpenChange={(v) => { if (!v) { if (install) fecharInstall(); if (update) adiar(); } }}>
      <DialogContent className="max-w-sm w-[calc(100vw-2rem)] rounded-2xl" data-testid="avisos-app">
        <DialogHeader className="items-center text-center">
          <img src={ident.src("icone", icone)} alt="TRT Gestão" className="h-14 w-14 rounded-xl mx-auto object-cover" />
          <DialogTitle>{update ? "Nova versão disponível" : "TRT Gestão no seu celular"}</DialogTitle>
          <DialogDescription>{update ? "Deseja atualizar o TRT Gestão agora?" : "Tenha um atalho na tela inicial."}</DialogDescription>
        </DialogHeader>
        {update && <p className="text-xs text-slate-500 text-center">Salve o que estiver preenchendo antes de continuar.</p>}
        {update && (
          <div className="grid gap-2">
            <Button onClick={atualizar} className="bg-[hsl(var(--gold))] hover:bg-[hsl(var(--gold-hover))] text-white" data-testid="atualizar-sim">Sim, atualizar</Button>
            <Button variant="outline" onClick={adiar} data-testid="atualizar-nao">Agora não</Button>
          </div>
        )}
        {install && (
          <div className="space-y-3">
            {update && <div className="border-t pt-3 text-sm font-semibold">Como adicionar à tela inicial</div>}
            <InstrucoesInstalacao />
            {isIOS() && <p className="text-xs text-slate-500">Dica: no iPhone use o Safari para adicionar o atalho.</p>}
            <Button onClick={fecharInstall} className="w-full bg-[hsl(var(--gold))] hover:bg-[hsl(var(--gold-hover))] text-white" data-testid="install-entendi">Entendi</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
